import { Injectable, inject } from '@angular/core';
import { AnalyticsService } from '@athena/util-monitoring';

export const SIGNUP_SOURCES = [
  'top-nav-desktop',
  'top-nav-mobile',
  'pet-card-teaser',
  'pet-details-teaser',
  'pet-details-card-teaser',
  'favourite-modal',
  'browse-hero',
  'find-your-match-nav-desktop',
  'find-your-match-nav-mobile',
  'find-your-match-direct',
  'browse-teaser-sheet',
] as const;
export type SignupSource = (typeof SIGNUP_SOURCES)[number];

@Injectable({ providedIn: 'root' })
export class AuthAnalyticsService {
  readonly #analytics = inject(AnalyticsService);

  loginInitiated(): void {
    this.#analytics.trackEvent('auth::login::initiated');
  }

  signupInitiated(source: SignupSource): void {
    this.#analytics.trackEvent('auth::signup::initiated', { source });
  }

  callbackLanded(): void {
    this.#analytics.trackEvent('auth::callback::landed');
  }

  loginCompleted(firstSession?: boolean): void {
    this.#analytics.trackEvent('auth::login::completed', firstSession === undefined ? {} : { firstSession });
  }

  logoutInitiated(): void {
    this.#analytics.trackEvent('auth::logout::initiated');
  }

  verifyResendClicked(): void {
    this.#analytics.trackEvent('auth::verify::resendClicked');
  }

  errorRetryClicked(): void {
    this.#analytics.trackEvent('auth::error::retryClicked');
  }

  verifiedSignInClicked(): void {
    this.#analytics.trackEvent('auth::verified::signInClicked');
  }
}
